// extracted by mini-css-extract-plugin
export var autoExpand = "_1x-b";
export var container = "_1x-a";
export var containerWidth = "_1x-8";
export var disabled = "_1x-2";
export var error = "_1x-3";
export var fullWidth = "_1x-9";
export var highlightContainer = "_1x-5";
export var inputWrapper = "_1x-0";
export var small = "_1x-1";
export var textarea = "_1x-4";
export var validatedTextarea = "_1x-6";
export var visuallyHidden = "_1x-7";